module.exports = __webpack_public_path__ + "img/img_detail2.da6ce0cf.png";